import Reflux from 'reflux';

const AuditLogLicenseActions = Reflux.createActions({
  getLicenseStatus: { asyncResult: true },
});

export default AuditLogLicenseActions;



// WEBPACK FOOTER //
// ./src/web/AuditLogLicenseActions.jsx